import DeviceData from './DeviceData';
import DeviceItem from './DeviceItem';

function PumpDevice(props) {
	return <DeviceItem {...props} data={DeviceData.PUMP} />;
}

export default PumpDevice;
